export { default as ContextualHeader } from './Header.vue';

export const SECTION_TYPES = {
	HERO: 'hero',
	CONTACT: 'contact',
	OVERVIEW: 'overview',
	MAP: 'map',
	EXCLUSIVITIES: 'exclusivities',
	CHARACTERISTICS: 'characteristics',
	SELL: 'sell',
	CONDO: 'condo',
	LOCATION: 'location',
	SHORTS: 'shorts',
	CHOSEN_FOR_YOU: 'chosen-for-you',
	SIMILAR_PROPERTIES: 'similar-properties'
} as const;

export type SectionType = (typeof SECTION_TYPES)[keyof typeof SECTION_TYPES];
